class PredictiveCollection extends SearchForm {
  constructor() {
    super();

    this.collection = this.getAttribute("data-collection");
    
    this.predictiveSearchWrapper = this.querySelector("[data-predictive-search]");
    this.predictiveSearchResults = this.querySelector("[data-predictive-collection]");
    this.loader = this.querySelector(".predictive-search__loading-state");

    this.input = this.querySelector('[name="q"]');
    this.input.addEventListener("input", this.onChange.bind(this));

    this.zoho = {
      market: this.querySelector('#input_register_market'),
      product: this.querySelector('#input_register_product'),
      date: this.querySelector('#input_register_date'),
      firstName: this.querySelector('#input_register_first_name'), 
      lastName: this.querySelector('#input_register_last_name'), 
      email: this.querySelector('#input_register_email'), 
      productImage: this.querySelector('#input_register_product_image'),
    }

    // set zoho form - market
    this.markets = this.querySelectorAll(".item_market");
    this.markets.forEach((market) => {
      market.addEventListener("click", () => {
        this.collection = market.dataset.value;
        this.setInputVal(this.zoho.market, this.collection);
        this.fetchData();
      });
    });

    // set zoho form - date
    this.dateInput = this.querySelector("#ContactForm-date");
    this.dateInput.addEventListener("input", () => {
      this.date = new Date(this.dateInput.value);
      
      if(this.date.getDate() < 10) {
        this.day = '0' + this.date.getDate();
      } else {
        this.day = this.date.getDate();
      }

      this.month = this.date.getMonth();      
      this.year = this.date.getFullYear();

      switch(this.month){
        case 11: 
          this.month = 'Dec';
          break;
        case 10: 
          this.month = 'Nov';
          break;
        case 9: 
          this.month = 'Oct';
          break;
        case 8: 
          this.month = 'Sep';
          break;
        case 7: 
          this.month = 'Aug';
          break;
        case 6: 
          this.month = 'Jul';
          break;
        case 5: 
          this.month = 'Jun';
          break;
        case 4: 
          this.month = 'May';
          break;
        case 3: 
          this.month = 'Apr';
          break;
        case 2: 
          this.month = 'Mar';
          break;
        case 1:
          this.month = 'Feb';
          break;
        case 0:
          this.month = 'Jan';
          break;
      }

      this.zoho.date.value = `${this.day}-${this.month}-${this.year}`;
    });

    // Set Zoho form - first name, last name, email
    this.inputTarget = this.querySelectorAll('[data-target]');
    this.inputTarget.forEach(item => {
      let selectedItem = item;
      item.addEventListener("input", () => {
        let target = selectedItem.dataset.target;
        document.getElementById(target).value = selectedItem.value;
        console.log('product', this.zoho.product.value)
      });
    })

    // fetch collection products
    this.fetchData();
  }

  setInputVal(input, val){
    input.value = val;
  }

  fetchData() {
    // fetch('/collections/' + this.collection + '?view=collection-search')
    fetch('/collections/all?view=collection-search')
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html").querySelector("#shopify-section-collection-search").innerHTML;

        this.predictiveSearchResults.innerHTML = responseHTML;
        this.loader.classList.add('hidden');
      })
      .catch((error) => {
        console.log("no products found with market ==>", error);
      });
  }

  onChange() {
    let filter = this.input.value.toUpperCase();
    let ul = this.predictiveSearchResults.querySelector("ul");
    let li = ul.getElementsByTagName("li");
    
    for (let i = 0; i < li.length; i++) {
        let title = li[i].getElementsByTagName("my-value")[0];
        let txtValue = title.textContent || title.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
        } else {
            li[i].style.display = "none";
        }
    }

    this.predictiveSearchWrapper.style.display = "block"
    this.predictiveSearchResults.style.display = "block"
  }
}

customElements.define("predictive-collection", PredictiveCollection);
